import React from "react";
import "./WhyUs.css";

const WhyUs = () => {
  const pillars = [
    {
      icon: "fa-solid fa-user-doctor",
      title: "23+ Years Surgical Mastery",
      description: "MS Orthopedics from premier PGI Chandigarh, with high-volume surgical proficiency across premier tertiary hospitals.",
    },
    {
      icon: "fa-solid fa-microscope",
      title: "Keyhole Arthroscopy Pioneer",
      description: "State-of-the-art minimally invasive knee and shoulder arthroscopy ensuring faster rehabilitation and minimal tissue trauma.",
    },
    {
      icon: "fa-solid fa-robot",
      title: "Computer & Robotic Precision",
      description: "Robotic-assisted and computer-navigated joint replacement for sub-millimeter implant alignment and prolonged implant longevity.",
    },
    {
      icon: "fa-solid fa-heart-pulse",
      title: "Holistic Joint Preservation",
      description: "Conservative cartilage restoration, targeted joint injections, and personalized rehabilitation before recommending replacement.",
    },
  ];

  return (
    <section className="whyus-section section-padding">
      <div className="container">
        <div className="text-center mb-5">
          <span className="section-header-pill">
            <i className="fa-solid fa-medal me-1"></i> Patient Centered Excellence
          </span>
          <h2 className="section-title-large">Why Choose Dr. Sunil Apsingi?</h2>
          <p className="section-subtitle-muted">
            Combining academic pedigree with decades of operative excellence to deliver predictable, pain-free mobility.
          </p>
        </div>

        <div className="row g-4">
          {pillars.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6">
              <div className="whyus-card h-100 p-4">
                <div className="whyus-icon-wrapper mb-3">
                  <i className={item.icon}></i>
                </div>
                <h4 className="whyus-title mb-2">{item.title}</h4>
                <p className="whyus-desc mb-0">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
